const white = '#fff';
const lightGrey = '#ccc';
const grey = '#828282';
const blue = '#0074E8';
const mediumBlue = '#0070b9';
const darkBlue = '#37435c';
const green = '#a6e400';
const dodgerBlue = '#20A2FF';
const malibu = '#66BFFF';

export default {
  accent: mediumBlue,
  background: white,
  branches: {
    background: white,
    button: {
      activeBackground: '#a8cf38',
      activeBorderColor: '#a8cf38',
      activeColor: white,
      background: blue,
      borderColor: blue,
      color: white,
      hoverBackground: mediumBlue,
      hoverBorderColor: mediumBlue,
      hoverColor: white,
    },
    color: '#333333',
    errorBodyCopy: {
      color: '#333333',
    },
    errorHeader: {
      color: '#333333',
    },
    errorLink: {
      color: mediumBlue,
    },
    errorSubHeader: {
      color: '#333333',
    },
    header: {
      background: darkBlue,
      color: white,
    },
    heroDescription: {
      color: '#333333',
    },
    heroValue: {
      color: mediumBlue,
    },
    product: {
      background: 'rgba(173, 226, 255, 0.2)',
    },
    productHeader: {
      background: mediumBlue,
      color: white,
    },
    subCategory: {
      color: darkBlue,
    },
    subnavigation: {
      activeBackground: '#37435c',
      activeColor: '#ffffff',
      background: '#ededed',
      color: '#47415d',
    },
    tab: {
      activeBorderColor: '#a8cf38',
      activeColor: '#333333',
      background: white,
      color: mediumBlue,
    },
  },
  colors: {},
  error: '#df0000',
  focus: {
    dark: malibu,
    normal: dodgerBlue,
  },
  form: {
    active: blue,
    border: lightGrey,
    placeholder: '#808285',
    text: darkBlue,
  },
  grey: {
    light: lightGrey,
    normal: grey,
  },
  icon: darkBlue,
  info: blue,
  primary: white,
  progress: {
    background: darkBlue,
    complete: green,
    inComplete: white,
  },
  secondary: blue,
  text: darkBlue,
};
